import React from 'react';

const WaflowSettingsSection = ({ clinic, editedClinic, setEditedClinic, isEditing }) => {
  const settings = isEditing ? editedClinic?.settings : clinic?.settings;
  const waflowSettings = settings?.integration?.waflow;

  console.log('WaflowSettingsSection - isEditing:', isEditing);
  console.log('WaflowSettingsSection - settings:', settings);
  console.log('WaflowSettingsSection - waflowSettings:', waflowSettings);

  const handleWaflowSettingsChange = (field, value) => {
    if (!isEditing) return;

    setEditedClinic(prev => ({
      ...prev,
      settings: {
        ...prev.settings || {},
        integration: {
          ...prev.settings?.integration || {},
          waflow: {
            ...prev.settings?.integration?.waflow || {},
            [field]: value
          }
        }
      }
    }));
  };

  if (!isEditing) {
    // Read-only view
    return (
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h4 className="text-md font-semibold mb-4">Waflow Integration</h4>

        {waflowSettings?.enabled ? (
          <div className="space-y-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Public Key</label>
                <p className="text-sm text-gray-900 mt-1">{waflowSettings.public_key || '-'}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Private Key</label>
                <p className="text-sm text-gray-900 mt-1">
                  {waflowSettings.private_key ? '••••••••••••••••' : '-'}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <p className="text-gray-500">Waflow integration is not enabled.</p>
        )}
      </div>
    );
  }

  // Edit mode
  return (
    <div className="mt-6 pt-6 border-t border-gray-200">
      <h4 className="text-md font-semibold mb-4">Waflow Integration</h4>

      <div className="flex items-start space-x-4 mb-4">
        <div className="flex items-center h-5">
          <input
            id="waflow_enabled"
            name="waflow_enabled"
            type="checkbox"
            checked={waflowSettings?.enabled || false}
            onChange={(e) => handleWaflowSettingsChange('enabled', e.target.checked)}
            className="h-4 w-4 text-blue-600 border-gray-300 rounded"
          />
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor="waflow_enabled" className="font-medium text-gray-700">
            Enable Waflow Integration
          </label>
          <p className="text-gray-500">
            When enabled, the system will integrate with Waflow for enhanced workflow automation.
          </p>
        </div>
      </div>

      {waflowSettings?.enabled && (
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Public Key
              </label>
              <textarea
                value={waflowSettings?.public_key || ''}
                onChange={(e) => handleWaflowSettingsChange('public_key', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="Enter public key"
              />
              <p className="mt-1 text-xs text-gray-500">
                The public key for authenticating with the Waflow API.
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Private Key
              </label>
              <textarea
                value={waflowSettings?.private_key || ''}
                onChange={(e) => handleWaflowSettingsChange('private_key', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="Enter private key"
              />
              <p className="mt-1 text-xs text-gray-500">
                The private key for authenticating with the Waflow API. This will be stored securely.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WaflowSettingsSection;
